import { Link } from "react-router-dom";
import { ArrowLeft, X } from "lucide-react";

/**
 * Landing page after Stripe checkout cancel — reassures the buyer no
 * charge was made and offers to keep exploring the free pages.
 */
export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
      <span
        className="inline-flex w-16 h-16 rounded-3xl items-center justify-center mb-6"
        style={{ background: "#F0EBFF", color: "#6B47C7" }}
      >
        <X size={30} />
      </span>
      <h1 className="font-fredoka text-4xl sm:text-5xl" style={{ color: "#2D3055" }}>
        No worries — nothing was charged.
      </h1>
      <p className="mt-4 font-nunito text-lg" style={{ color: "#4A4E6D" }}>
        You can keep exploring the free coloring pages any time. The whole
        book is still just a click away when you're ready. 🐾
      </p>
      <Link to="/books" className="btn-terracotta mt-8 inline-flex" data-testid="payment-cancel-back">
        <ArrowLeft size={14} /> Back to the books
      </Link>
    </div>
  );
}
